module.exports = __webpack_public_path__ + "img/P150T_weapon_13.bb2d8b47.png";